import Radium from "radium";
import React from "react";

import { remoStyles } from "@common/styles";
import { IDevice } from "@common/models";

export interface IApproveDeviceProps {
  closeModal: () => void;
  device: IDevice;
  approveDevice: () => void;
}

class ApproveDevice extends React.Component<IApproveDeviceProps, any> {
  public render() {
    const remoCancelButtonStyle = {
      ...remoStyles.okButton,
      backgroundColor: "#444"
    };

    const { device, approveDevice, closeModal } = this.props;
    return (
      <div style={remoStyles.container as any}>
        <div style={remoStyles.header as any}>Godkjenn enhet</div>
        <div style={remoStyles.text as any}>
          Er du sikker på at du vil godkjenne enheten{" "}
          {device ? device.userAgent || device.deviceId : undefined}?
        </div>
        <div style={remoStyles.okButton as any} onClick={approveDevice}>
          Godkjenn enhet
        </div>
        <div style={remoCancelButtonStyle as any} onClick={closeModal}>
          Avbryt
        </div>
      </div>
    );
  }
}

export default Radium(ApproveDevice);
